/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountLoyaltyDrawResponse,
  CreateDrawRequest,
  CreateDrawResponse,
  DrawDetailResponse,
  DrawRewardRequest,
  DrawRewardResponse,
  GetDrawWinnersResponse,
  ListDrawsResponse,
  PrizeDrawEntryWinner,
  UpdateDrawRequest,
  UpdatePrizeDrawEntryWinnerRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Returns the account's eligibility for the currently active prize draw along with their entries if applicable.
 */
export const getActiveDrawInfoForAccount = (
  billingAccountId: number,
  options?: SecondParameter<
    typeof backofficeRequest<AccountLoyaltyDrawResponse>
  >,
) => {
  return backofficeRequest<AccountLoyaltyDrawResponse>(
    { url: `/accounts/${billingAccountId}/loyalty/draw`, method: "GET" },
    options,
  )
}
/**
 * Creates a new prize draw with rewards.
 */
export const createDraw = (
  createDrawRequest: CreateDrawRequest,
  options?: SecondParameter<typeof backofficeRequest<CreateDrawResponse>>,
) => {
  return backofficeRequest<CreateDrawResponse>(
    {
      url: `/loyalty/draws`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDrawRequest,
    },
    options,
  )
}
/**
 * Lists all prize draws.
 */
export const listDraws = (
  options?: SecondParameter<typeof backofficeRequest<ListDrawsResponse>>,
) => {
  return backofficeRequest<ListDrawsResponse>(
    { url: `/loyalty/draws`, method: "GET" },
    options,
  )
}
/**
 * Returns information about a prize draw.
 */
export const getDrawDetail = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<DrawDetailResponse>>,
) => {
  return backofficeRequest<DrawDetailResponse>(
    { url: `/loyalty/draws/${drawId}`, method: "GET" },
    options,
  )
}
/**
 * Update the prize draw. Cannot update any closed, or active draws.
 */
export const updateDraw = (
  drawId: number,
  updateDrawRequest: UpdateDrawRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/loyalty/draws/${drawId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDrawRequest,
    },
    options,
  )
}
/**
 * Allocates prizes to the approved winners.
 */
export const allocatePrizes = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/loyalty/draws/${drawId}/allocatePrizes`, method: "POST" },
    options,
  )
}
/**
 * Returns the winners associated with the current draw
 */
export const getDrawWinners = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<GetDrawWinnersResponse>>,
) => {
  return backofficeRequest<GetDrawWinnersResponse>(
    { url: `/loyalty/draws/${drawId}/winners`, method: "GET" },
    options,
  )
}
/**
 * Generate new winners from rejected winners
 */
export const reprocessDrawWinners = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/loyalty/draws/${drawId}/winners/reprocess`, method: "POST" },
    options,
  )
}
/**
 * Reveals the 'you won' modal to winners immediately, ahead of the winner notification date
 */
export const winnersNotified = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/loyalty/draws/${drawId}/winners/notify`, method: "POST" },
    options,
  )
}
/**
 * Update fields of a given winner
 */
export const updateWinner = (
  drawId: number,
  winnerId: number,
  updatePrizeDrawEntryWinnerRequest: UpdatePrizeDrawEntryWinnerRequest,
  options?: SecondParameter<typeof backofficeRequest<PrizeDrawEntryWinner>>,
) => {
  return backofficeRequest<PrizeDrawEntryWinner>(
    {
      url: `/loyalty/draws/${drawId}/winners/${winnerId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updatePrizeDrawEntryWinnerRequest,
    },
    options,
  )
}
/**
 * Create the given prize draw reward.
 */
export const createPrizeDrawReward = (
  drawId: number,
  drawRewardRequest: DrawRewardRequest,
  options?: SecondParameter<typeof backofficeRequest<DrawRewardResponse>>,
) => {
  return backofficeRequest<DrawRewardResponse>(
    {
      url: `/loyalty/draws/${drawId}/rewards`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: drawRewardRequest,
    },
    options,
  )
}
/**
 * Close the prize draw and begin the background process for calculating winners.
 */
export const closePrizeDraw = (
  drawId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/loyalty/draws/${drawId}/close`, method: "POST" },
    options,
  )
}
/**
 * Update the given prize draw reward.
 */
export const updatePrizeDrawReward = (
  drawId: number,
  rewardId: number,
  drawRewardRequest: DrawRewardRequest,
  options?: SecondParameter<typeof backofficeRequest<DrawRewardResponse>>,
) => {
  return backofficeRequest<DrawRewardResponse>(
    {
      url: `/loyalty/draws/${drawId}/rewards/${rewardId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: drawRewardRequest,
    },
    options,
  )
}
/**
 * Delete a given reward from the prize draw.
 */
export const deletePrizeDrawReward = (
  drawId: number,
  rewardId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/loyalty/draws/${drawId}/rewards/${rewardId}`, method: "DELETE" },
    options,
  )
}
export type GetActiveDrawInfoForAccountResult = NonNullable<
  Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>
>
export type CreateDrawResult = NonNullable<
  Awaited<ReturnType<typeof createDraw>>
>
export type ListDrawsResult = NonNullable<Awaited<ReturnType<typeof listDraws>>>
export type GetDrawDetailResult = NonNullable<
  Awaited<ReturnType<typeof getDrawDetail>>
>
export type UpdateDrawResult = NonNullable<
  Awaited<ReturnType<typeof updateDraw>>
>
export type AllocatePrizesResult = NonNullable<
  Awaited<ReturnType<typeof allocatePrizes>>
>
export type GetDrawWinnersResult = NonNullable<
  Awaited<ReturnType<typeof getDrawWinners>>
>
export type ReprocessDrawWinnersResult = NonNullable<
  Awaited<ReturnType<typeof reprocessDrawWinners>>
>
export type WinnersNotifiedResult = NonNullable<
  Awaited<ReturnType<typeof winnersNotified>>
>
export type UpdateWinnerResult = NonNullable<
  Awaited<ReturnType<typeof updateWinner>>
>
export type CreatePrizeDrawRewardResult = NonNullable<
  Awaited<ReturnType<typeof createPrizeDrawReward>>
>
export type ClosePrizeDrawResult = NonNullable<
  Awaited<ReturnType<typeof closePrizeDraw>>
>
export type UpdatePrizeDrawRewardResult = NonNullable<
  Awaited<ReturnType<typeof updatePrizeDrawReward>>
>
export type DeletePrizeDrawRewardResult = NonNullable<
  Awaited<ReturnType<typeof deletePrizeDrawReward>>
>
